export enum AddGameActionNameEnum {
  submitted = 'submitted',
  saved = 'saved',
  save = 'save',
  submit = 'submit',
}
